import { Appinfo } from '../nebula-class/modules/appinfo';
import loadArmsAsync from '../nebula-class/loadArmsAsync';
var appInfo = new Appinfo();
var initArms = false;
if (!initArms && window) {
    initArms = true;
    loadArmsAsync(appInfo);
}
export default appInfo;